// extracted by mini-css-extract-plugin
export default {"header-row_selected":"styles_header-row_selected__0hpk+","body-row_selected":"styles_body-row_selected__S6d7A"};